import { type ReactNode } from 'react';

export function WelcomeMessageWrapper({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-12 w-full">
      <div className="flex flex-col items-center w-full">
        <div className="text-center text-neutral-700 leading-[1.33] mb-0">{children}</div>
      </div>
    </div>
  );
}
